import React, { useEffect, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { debounce } from "lodash";
import { useStoreState, useStoreActions } from "easy-peasy";
import { checkIfPortrait } from "../../utils/screen";
import { isMobile } from "../../utils/ResponsiveUtils";
import analytics from "../../utils/analytics";
import { isWhiteListed } from "./helpers";

const RotateIndicator = ({ content, mobileResponsiveUtil }) => {
  const CONTAINER_ID = "interactiveExpRotateInd";
  const { text, button = {}, background = {} } = content;
  const [isPortrait, setIsPortrait] = useState(null);
  const [showPlaceholder, setShowPlaceholder] = useState(isWhiteListed());

  const { isPlaying: isExperiencePlaying } = useStoreState(
    (state) => state.experience
  );
  const { player: videoPlayer } = useStoreState((state) => state.stage);
  const { player: bgmPlayer } = useStoreState((state) => state.bgm);
  const setVideoPlaying = useStoreActions(
    (actions) => actions.stage.setPlaying
  );

  const { buildUrl } = document.getElementById(
    "irobot-embedded-interactive-experience"
  ).dataset;

  const checkOrientation = () => {
    if (!checkIfPortrait()) {
      setIsPortrait(false);
    } else {
      setIsPortrait(true);
    }
  };
  const handleResize = useCallback(() => {
    checkOrientation();
    if (!checkIfPortrait()) {
      if (isExperiencePlaying) {
        if (videoPlayer) {
          setVideoPlaying(true);
        }
        if (bgmPlayer && bgmPlayer.readyState() > 3) {
          bgmPlayer.play();
        }
      } else {
        if (videoPlayer && !videoPlayer.paused()) {
          setVideoPlaying(false);
        }
        if (bgmPlayer && !bgmPlayer.paused()) {
          bgmPlayer.pause();
        }
      }
    }
  }, [videoPlayer, setVideoPlaying, isExperiencePlaying, bgmPlayer]);

  useEffect(() => {
    window.addEventListener("resize", debounce(handleResize, 250));
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  useEffect(() => {
    checkOrientation();
    return () => {};
  }, []);

  useEffect(() => {
    if (isPortrait && isMobile() && showPlaceholder && text) {
      analytics.trackPortrait();
    }
    return () => {};
  }, [isPortrait, showPlaceholder, text]);

  return (
    <>
      {!showPlaceholder && button.text && (
        <div id={CONTAINER_ID} className="start-screen rotate-indicator">
          <button
            className="experience-intro__btn"
            type="button"
            onClick={() => setShowPlaceholder(true)}
          >
            <span className="experience-intro__btn__inner">
              <span className="experience-intro__btn-label">{button.text}</span>
            </span>
          </button>
        </div>
      )}
      {showPlaceholder && text && (
        <div id={CONTAINER_ID} className="rotate-indicator">
          <div className="rotate-indicator__inner">
            <div className="rotate-indicator__img">
              <img
                src={`${buildUrl}/images/rotate-indicator/rotate-cropped.png`}
                alt="Please rotate your device to landscape"
              />
            </div>
            <h2
              className="rotate-indicator__title"
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        </div>
      )}

      <style jsx="true">
        {`
          #${CONTAINER_ID}.rotate-indicator {
            z-index: -1 !important;

            display: none !important;

            width: 100% !important;
            height: 100% !important;

            opacity: 0 !important;
            background-color: #2f2d2e !important;
          }

          #${CONTAINER_ID}.start-screen.rotate-indicator {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            background-image: url('${background.backgroundUrl}') !important;
            background-position: center !important;
            background-size: cover !important;
          }

          #${CONTAINER_ID} .rotate-indicator__inner {
            position: absolute !important;
            top: 50% !important;
            left: 0 !important;

            width: 100% !important;

            transform: translateY(-50%) !important;
          }

          #${CONTAINER_ID} .rotate-indicator__img {
            width: ${mobileResponsiveUtil.getWidthValue(522)}px !important;
            margin: 0 auto !important;
          }
          #${CONTAINER_ID} .rotate-indicator__img img {
            display: block !important;

            width: 100% !important;
            height: auto !important;
          }
          #${CONTAINER_ID} .rotate-indicator__title {
            color: #ffffff !important;
            margin: 0 auto !important;
            line-height: 1.3 !important;
            margin-top: ${mobileResponsiveUtil.getHeightValue(
              120
            )}px !important;
            padding: 0 !important;
            font-weight: 300 !important;
            font-family: "HarmoniaSans", sans-serif !important;
            width: ${mobileResponsiveUtil.getWidthValue(522)}px !important;
            text-align: center !important;
          }
          #${CONTAINER_ID} .rotate-indicator__title strong {
            font-weight: 700 !important;
          }
          
          #${CONTAINER_ID} .experience-intro__btn {
            max-width: 80% !important;
            font-size: ${mobileResponsiveUtil.getFontSize(68)}px !important;
            font-family: ${button.font} !important;
            display: flex !important;
            padding: ${mobileResponsiveUtil.getHeightValue(9)}px 
                      ${mobileResponsiveUtil.getHeightValue(9)}px !important;

            text-align: center !important;
            letter-spacing: 0.7px !important;

            color: ${button.color} !important;
            border: 0 !important;
            border-radius: ${mobileResponsiveUtil.getWidthValue(
              0
            )}px !important;
            background: ${button.bgColor} !important;
            box-shadow: none !important;
            align-items: center !important;
            justify-content: flex-start !important;
            overflow: hidden !important;
          }
          #${CONTAINER_ID} .experience-intro__btn:hover,
          #${CONTAINER_ID} .experience-intro__btn *:hover{
            cursor: pointer !important;
          }
          #${CONTAINER_ID} .experience-intro__btn__inner {
            display: flex !important;
            justify-content: center !imporntant;
          }
            
          #${CONTAINER_ID} .experience-intro__btn-label {
            font-weight: 600 !important;
          }

          @media screen and (orientation: portrait) {
            ${
              isMobile() &&
              `
            #${CONTAINER_ID}.rotate-indicator {
              position: absolute !important;
              z-index: 9999 !important;

              display: block !important;

              opacity: 1 !important;
            }
          `
            }
          }
        `}
      </style>
    </>
  );
};
RotateIndicator.propTypes = {
  content: PropTypes.object,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
};

RotateIndicator.defaultProps = {
  content: {
    text: "",
  },
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};
export default RotateIndicator;
